<template>
  <b-container>
    <v-sheet>
      <v-calendar ref="calendar" :event-color="getEventColor" :events="events" :start="startDate"
        :weekday-format="myDayFormat" :weekdays="weekView" color="primary" type="week">
        <template v-slot:day-label-header="{}">
          <div></div>
        </template>
        <template v-slot:event="{ event }">
          <div class="fill-height cursor-point" layout="column" @click.stop="openModalInfoHour(event)">
            {{
              event.start.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
            -
            {{
              event.end.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}

            <i class="fas fa-trash" @click.stop="
              deleteHourScheduleInDaySchedule(
                event.idWorkschedule,
                event.idDay,
                event.id
              )
            "></i>
            <b-form-group>
              <ul v-if="event.visitTypes" class="list-group">
                <li v-for="(item, index) in event.visitTypes" :key="index" class="list-group-item">
                  <i :style="'color: ' + item.colour" class="fas fa-circle mr-2"></i>
                  {{ item.name }}
                </li>
              </ul>
            </b-form-group>
          </div>
        </template>
      </v-calendar>
    </v-sheet>

    <b-modal id="modal-schedule" cancel-title="Cerrar" centered ok-title="Seleccionar" size="lg" @ok="saveFormStep2">
      <template #modal-title>{{
        $t(
          "public.components.workschedule.WorkscheduleGlobal.schedule.modal.select"
        )
      }}
      </template>
      <form action="#">
        <b-form-group label-for="timeStartSchedule">
          <template slot="label">{{
            $t(
              "public.components.workschedule.WorkscheduleGlobal.schedule.modal.timeStartSchedule"
            )
          }}: *
          </template>
          <b-form-input id="timeStartSchedule" v-model="timeStartSchedule" :disabled="disabled" type="time" v-bind:class="{
            'text-danger': isFormTimeStartScheduleErrors,
            'is-invalid': isFormTimeStartScheduleErrors,
          }" @blur="checkTimeStartSchedule(timeStartSchedule)"></b-form-input>
          <ul v-if="isFormTimeStartScheduleErrors">
            <li v-for="(error, index) in validatorStep1.getErrors(
              'timeStartSchedule'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="timeEndSchedule">
          <template slot="label">{{
            $t(
              "public.components.workschedule.WorkscheduleGlobal.schedule.modal.timeEndSchedule"
            )
          }}: *
          </template>
          <b-form-input id="timeEndSchedule" v-model="timeEndSchedule" :disabled="disabled" type="time" v-bind:class="{
            'text-danger': isFormTimeEndScheduleErrors,
            'is-invalid': isFormTimeEndScheduleErrors,
          }" @blur="checkTimeEndSchedule(timeStartSchedule, timeEndSchedule)"></b-form-input>
          <ul v-if="isFormTimeEndScheduleErrors">
            <li v-for="(error, index) in validatorStep1.getErrors(
              'timeEndSchedule'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="daySchedule">
          <template slot="label">{{
            $t(
              "public.components.workschedule.WorkscheduleGlobal.schedule.modal.daySchedule"
            )
          }}: *
          </template>
          <b-select id="daySchedule" v-model="daySchedule" :options="daysSelect" v-bind:class="{
            'text-danger': isFormDayScheduleErrors,
            'is-invalid': isFormDayScheduleErrors,
          }"></b-select>
          <ul v-if="isFormDayScheduleErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('daySchedule')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="visitType">
          <template slot="label">
            {{
              $t("public.components.workschedule.WorkscheduleGlobal.visitType")
            }}: *
          </template>

          <multiselect v-model="visitTypes" :clear-on-select="false" :close-on-select="false" :multiple="true"
            :options="visitTypeSelect" :preserve-search="true" label="text" track-by="value" v-bind:class="{
              'text-danger': isFormVisitTypesErrors,
              'is-invalid': isFormVisitTypesErrors,
            }" v-bind:deselectGroupLabel="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.deselectGroupLabel'
  )
" v-bind:deselectLabel="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.components.workschedule.WorkscheduleGlobal.multiselect.selectedLabel'
  )
" @blur="checkVisitTypes(visitTypes)">
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i><span
                  class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
              </b-list-group-item>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{ values.length }}
                {{
                  $t(
                    "public.components.workschedule.WorkscheduleGlobal.selectedVisitType"
                  )
                }}</span></template>
          </multiselect>
          <ul v-if="isFormVisitTypesErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('visitTypes')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal id="modal-info-schedule" cancel-title="Cerrar" centered hide-footer size="lg">
      <template #modal-title>{{
        $t("public.components.workschedule.WorkscheduleGlobal.modal.info")
      }}
      </template>
      <b-form-group label-for="dayScheduleInfo">
        <template slot="label">{{
          $t("public.components.workschedule.WorkscheduleGlobal.modal.day")
        }}:
        </template>
        <ul class="list-group">
          <li v-if="dayScheduleInfo" class="list-group-item">
            {{ dayScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="timeStartScheduleInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleGlobal.modal.initialHour"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="timeStartScheduleInfo" class="list-group-item">
            {{ timeStartScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="timeEndScheduleInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleGlobal.modal.endHour"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="timeEndScheduleInfo" class="list-group-item">
            {{ timeEndScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="visitTypesInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleGlobal.modal.visitType"
          )
        }}:
        </template>
        <ul v-if="visitTypesInfo" class="list-group">
          <li v-for="(item, index) in visitTypesInfo" :key="index" class="list-group-item">
            <i :style="'color: ' + item.colour" class="fas fa-circle mr-2"></i>
            {{ item.name }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";
//JSON Mock
import DaySelect from "../../json/Day";

import validator from "vue-m-validator";
import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import professionalService from "../../services/professional";
import scheduleService from "../../services/schedule";
import utilsService from "../../services/utils";

export default {
  name: "WorkscheduleGlobal",
  props: ["updateDataComponets", "idProfessional"],
  mounted() {
    xray.index();
    this.getAllVisitType();
    this.getAllSchedules();
  },
  components: {
    validator,
  },
  computed: {
    //FormSchedule
    isFormVisitTypesErrors() {
      let errors = this.validatorStep1.getErrors("visitTypes");
      return errors && errors.length > 0;
    },
    isFormTimeEndScheduleErrors() {
      let errors = this.validatorStep1.getErrors("timeEndSchedule");
      return errors && errors.length > 0;
    },
    isFormTimeStartScheduleErrors() {
      let errors = this.validatorStep1.getErrors("timeStartSchedule");
      return errors && errors.length > 0;
    },
    isFormDayScheduleErrors() {
      let errors = this.validatorStep1.getErrors("daySchedule");
      return errors && errors.length > 0;
    },
  },
  methods: {
    openModalInfoHour(item) {
      this.timeStartScheduleInfo = utilsService.adjustDateTime(moment(item.start).format("DD/MM/YYYY HH:mm"), "HH:mm");
      this.timeEndScheduleInfo = utilsService.adjustDateTime(moment(item.end).format("DD/MM/YYYY HH:mm"), "HH:mm");
      this.dayScheduleInfo = this.myDayFormatInfo(item.idDay);
      this.visitTypesInfo = item.visitTypes;

      this.$bvModal.show("modal-info-schedule");
    },
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                colour: item.colour,
                value: item.id,
                text: item.name,
              });
            });
            self.visitTypeSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllVisitTypeActive",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    myDayFormatInfo(day) {
      if (day === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }
      if (day === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }
      if (day === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }
      if (day === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }
      if (day === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }
      if (day === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }
      if (day === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
      return "";
    },
    myDayFormat(day) {
      if (day.weekday === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }
      if (day.weekday === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }
      if (day.weekday === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }
      if (day.weekday === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }
      if (day.weekday === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }
      if (day.weekday === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }
      if (day.weekday === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkVisitTypes(_visitTypes) {
      const visitTypes = _visitTypes;
      const RULE_1 = {
        expression: visitTypes.length === 0,
        name: "visitTypes",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleGlobal.errors.erVisitType"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeStartSchedule(_timeStartSchedule) {
      const TIMESTARTSCHEDULE = _timeStartSchedule.trim();
      const RULE_1 = {
        expression: !TIMESTARTSCHEDULE || TIMESTARTSCHEDULE === "",
        name: "timeStartSchedule",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleGlobal.errors.erInitialHour"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeEndSchedule(_timeStartSchedule, _timeEndSchedule) {
      const TIMESTARTSCHEDULE = _timeStartSchedule.trim();
      const TIMEENDSCHEDULE = _timeEndSchedule.trim();
      const RULE_1 = {
        expression: !TIMEENDSCHEDULE || TIMEENDSCHEDULE === "",
        name: "timeEndSchedule",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleGlobal.errors.erEndHour"
        ),
      };
      this.validatorStep1.addRule(RULE_1);

      const RULE_2 = {
        expression: moment(TIMESTARTSCHEDULE, [
          moment.ISO_8601,
          "HH:mm",
        ]).isAfter(moment(TIMEENDSCHEDULE, [moment.ISO_8601, "HH:mm"])),
        name: "timeEndSchedule",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleGlobal.errors.erHourEarlier"
        ),
      };
      this.validatorStep1.addRule(RULE_2);
      this.notFirst();
    },
    checkDaySchedule(_daySchedule) {
      const DAYSCHEDULE = _daySchedule.trim();
      const RULE_1 = {
        expression: !DAYSCHEDULE || DAYSCHEDULE === "",
        name: "daySchedule",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleGlobal.errors.erDay"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    clearFormSchedule() {
      this.timeStartSchedule = "";
      this.timeEndSchedule = "";
      this.daySchedule = "";
    },
    openModalSchedule(option, id) {
      this.optionModalSchedule = option;
      this.disabledSchedule = false;
      this.clearFormSchedule();
      this.validatorStep1.errors = [];
      this.$bvModal.show("modal-schedule");
    },
    saveSchedule() {
      if (this.optionModalSchedule === "create") {
        this.createHourScheduleInDaySchedule();
      }
    },
    createHourScheduleInDaySchedule() {
      let self = this;

      let cloneVisitTypes = JSON.parse(JSON.stringify(this.visitTypes));

      // VisitType
      if (cloneVisitTypes && cloneVisitTypes.length !== 0) {
        let visitTypeResult = [];
        cloneVisitTypes.forEach(function (item) {
          visitTypeResult.push(item.value);
        });

        cloneVisitTypes = visitTypeResult;
      } else {
        cloneVisitTypes = null;
      }

      let entity = {
        id: this.idSchedule,
        timeStart: this.timeStartSchedule,
        timeEnd: this.timeEndSchedule,
        day: this.daySchedule,
        visitTypes: cloneVisitTypes,
      };
      this.$awn.asyncBlock(
        professionalService.createHourScheduleInDayScheduleWorkschedule(
          this.idProfessional,
          entity
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.updateDataComponets();
            self.$bvModal.hide("modal-schedule");
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t(
              "public.components.workschedule.WorkscheduleGlobal.errorSwal.text"
            ),
            this.$i18n.t(
              "public.components.workschedule.WorkscheduleGlobal.errorSwal.text1"
            ),
            this.$i18n.t(
              "public.components.workschedule.WorkscheduleGlobal.errorSwal.text2"
            )
          );
        },
        " "
      );
    },
    deleteHourScheduleInDaySchedule(idWorkschedule, idDay, id) {
      let self = this;
      this.$awn.asyncBlock(
        professionalService.deleteHourScheduleInDayScheduleWorkschedule(
          this.idProfessional,
          idWorkschedule,
          idDay,
          id
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.updateDataComponets();
            self.$bvModal.hide("modal-schedule");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.deleteHourScheduleInDayScheduleWorkschedule",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: this.idProfessional,
              idWorkschedule: idWorkschedule,
              idDay: idDay,
              id: id
            }),
          });
        },
        " "
      );
    },
    async getAllSchedules() {
      let self = this;
      this.$awn.asyncBlock(
        professionalService.getAllSchedulesWorkschedule(this.idProfessional),
        (response) => {
          if (response) {
            self.events = [];
            response.data.forEach(function (item) {
              const event = {
                id: item.id,
                idWorkschedule: item.idWorkschedule,
                idDay: item.idDay,
                title: item.title,
                name: item.title,
                start: new Date(item.start),
                end: new Date(item.end),
                visitTypes: item.visitTypes,
                color: item.color,
                timed: item.timed,
              };
              self.startDate = new Date(item.start);
              self.events.push(event);
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllSchedulesWorkschedule",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: this.idProfessional
            }),
          });
        },
        " "
      );
    },
    checkFormStep2() {
      this.checkVisitTypes(this.visitTypes);
      this.checkTimeStartSchedule(this.timeStartSchedule);
      this.checkTimeEndSchedule(this.timeStartSchedule, this.timeEndSchedule);
      this.checkDaySchedule(this.daySchedule);
    },
    saveFormStep2(evt) {
      evt.preventDefault();
      this.checkFormStep2();
      if (this.validatorStep1.errors.length === 0) {
        this.saveSchedule();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.notification.error"
          ),
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.notification.descErrorStep2"
          ),
          type: "error",
        });
      }
    },
    //Schedule
    getEventColor(event) {
      return event.color;
    },
  },
  data() {
    return {
      startDate: new Date(),
      // Form hour info
      timeStartScheduleInfo: "",
      timeEndScheduleInfo: "",
      dayScheduleInfo: "",
      visitTypesInfo: [],

      //Form schedule
      timeStartSchedule: "",
      timeEndSchedule: "",
      daySchedule: "",
      visitTypes: [],
      daysSelect: DaySelect,
      weekView: [1, 2, 3, 4, 5, 6, 0],
      optionModal: "",
      disabled: false,
      isFirstRun: true,
      isValidateStep1: false,
      showSeason: true,
      validatorStep1: validator,
      visitTypeSelect: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.headers.initialDate"
          ),
          value: "dateStart",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.headers.dateEnd"
          ),
          value: "dateEnd",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.headers.allYear"
          ),
          value: "allYear",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleGlobal.headers.actions"
          ),
          value: "actions",
        },
      ],
      seasons: [],
      events: [],
    };
  },
  components: {
    Multiselect,
  },
};
</script>